import { gql } from '@apollo/client';

export const SCENARIO_FIELDS = gql`
  fragment ScenarioFields on Scenario {
    id
    index
    name
    startYear
    endYear
    targetYear
    note
    vacancyFactor
    headcountUtilization
    deskSharingRatio
    targetUsf
    calculatorType
    subtotalProgramMultiplier
    subtotalBuildingMultiplier
    projectId
    floorId
    buildingId
    department {
      id
      name
      secondaryIdentifier
    }
    growthYears
    growths
    base
    isDetailed
    isShared
    usf
    rsfLoadFactor
    storedWorkSeats
    areStoredWorkSeatsOutdated
    workSeatsRoundingSetting
    headcountSeatCountGrowthRate: hcscGrowthRate
    headcountSeatCountBase: hcscBase
    building {
      id
      city
      state
      streetAddress
      squareFeet
      circulationPercentage
      programSubtotalUsf
      programmingUsf
      esaRsfLoadFactor
      floors {
        id
        name
        totalFloorUsf
        rsfLoadFactor
        totalFloorRsf
        isRsfTotalLocked
      }
    }
  }
`;

export const WORKSHEET_FIELDS = gql`
  fragment WorksheetFields on Worksheet {
    id
    spaceAllocation
  }
`;

export const WORKSHEET_ROW_FIELDS = gql`
  fragment WorksheetRowFields on WorksheetRow {
    id
    child
    quantity
    seatCap
    sizeX
    sizeY
    usf
    ratio
    spaceId
    worksheetId
    scenarioId
    projectSpaceType {
      id
      icon
      previousId
      spaceType {
        id
        spaceType
        name
        isCustom
        icon
      }
      category {
        id
        name
        includeInTotalWorkSeats
        parentId
        defaultSpaceTypeCategory {
          id
          category
          name
          parentId
        }
      }
    }
  }
`;

export const SCENARIO_AND_WORKSHEET_FIELDS = gql`
  fragment ScenarioAndWorksheetFields on Scenario {
    id
    index
    name
    startYear
    endYear
    targetYear
    note
    vacancyFactor
    headcountUtilization
    deskSharingRatio
    targetUsf
    calculatorType
    subtotalProgramMultiplier
    subtotalBuildingMultiplier
    floorId
    buildingId
    growthYears
    growths
    base
    isDetailed
    isShared
    usf
    storedWorkSeats
    areStoredWorkSeatsOutdated
    rsfLoadFactor
    headcountSeatCountGrowthRate: hcscGrowthRate
    headcountSeatCountBase: hcscBase
    department {
      id
      name
      secondaryIdentifier
    }
    worksheet {
      id
      scenarioId
      spaceAllocation
      worksheetRows {
        id
        child
        quantity
        seatCap
        sizeX
        sizeY
        usf
        ratio
        spaceId
        projectSpaceType {
          id
          previousId
          spaceType {
            id
            spaceType
            name
            isCustom
            icon
          }
          category {
            id
            name
            parentId
            defaultSpaceTypeCategory {
              id
              category
              name
            }
          }
        }
      }
      notes {
        id
        note
        category
      }
      categories {
        categoryId
        visible
      }
    }
  }
`;
